interface ExternalIMLinksMap {
  [key: string]: string;
}

export const EXTERNAL_IM_LINKS: Readonly<ExternalIMLinksMap> = Object.freeze({
  TERMS_OF_USE: 'https://home.insurancemenu.com/terms-of-use',
  PRIVACY_POLICY: 'https://home.insurancemenu.com/privacy-policy',
  NEW_TO_IM: 'https://insurancemenu.zendesk.com/hc/en-us/requests/new?ticket_form_id=22748937556884',
  HELP_CENTER: 'https://insurancemenu.zendesk.com/hc/en-us',
  SUBMIT_NEW_TICKET: 'https://insurancemenu.zendesk.com/hc/en-us/requests/new',
});
